import { SIZE_COVER, SCALE, formatPageNumber } from '../../constants';
import bgTableContent from '@/assets/image/pdfexport/bg-table-contents.png';
import { Box, withStyles, Typography } from '@material-ui/core';
import React from 'react';

const width = SIZE_COVER.width * SCALE;
const height = SIZE_COVER.height * SCALE;

const TableContent = ({ pageMap, totalPages }) => {
  const items = [
    { label: "Hi! Here's a quick look …", count: pageMap?.start?.quickLook },
    { label: 'Attendance', count: pageMap?.start?.attendance },
    {
      label: 'Health Screening Findings',
      count: pageMap?.start?.healthScreenings,
    },
    {
      label: 'Lifestyle Questionnaire Findings',
      count: pageMap?.start?.lifestyle,
    },
    { label: "It's not goodbye. It's see you later …", count: totalPages },
  ].filter((it) => it.count != null);

  return (
    <CustomContainer>
      <Title>Table of contents</Title>
      {items.map((item, idx) => (
        <Item key={idx}>
          {item.label} <Count>{formatPageNumber(item.count)}</Count>
        </Item>
      ))}
    </CustomContainer>
  );
};

const CustomContainer = withStyles({
  root: {
    padding: `${64 * SCALE}px ${80 * SCALE}px 0`,
    height,
    width,
    margin: '0 auto',
    backgroundImage: `url(${bgTableContent})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
})(Box);

const Count = withStyles({
  root: {
    borderLeft: '1px solid #e0e0e0',
    paddingLeft: `${20 * SCALE}px`,
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 24 * SCALE,
    lineHeight: `${32 * SCALE}px`,
    color: '#333',
  },
})(Box);

const Item = withStyles({
  root: {
    backgroundColor: '#fff',
    borderRadius: `${10 * SCALE}px`,
    padding: `${20 * SCALE}px`,
    margin: `${20 * SCALE}px 0`,
    border: '1px solid #e0e0e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    fontSize: 12 * SCALE,
  },
})(Box);

const Title = withStyles({
  root: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 20 * SCALE,
    lineHeight: `${28 * SCALE}px`,
    marginBottom: 40 * SCALE,
  },
})(Typography);

export default TableContent;
